import { NoDataPlaceholder } from '../NoDataPlaceholder';
import { useRequestsWidgetPlaceholderStyles } from './useRequestsWidgetPlaceholderStyles';

export const RequestsWidgetPlaceholder = () => {
  const { classes } = useRequestsWidgetPlaceholderStyles();

  return (
    <div className={classes.root}>
      <NoDataPlaceholder className={classes.placeholder} />
    </div>
  );
};
